import { AccordionItem, ControlledAccordion, useAccordionProvider } from '@szhsin/react-accordion';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import config from '../config';
import { GlobalContext } from '../global/GlobalProvider';

export default function SettingPopup({className}) {
const { t, i18n } = useTranslation();
  const { loggedIn,setCurrentTheme } = useContext(GlobalContext);


const providerValue = useAccordionProvider({
    allowMultiple: true,
    transition: true,
    transitionTimeout: 250
  });
  const { toggle, toggleAll } = providerValue;
    const [isOpenProfile1, setIsOpenProfile1] = useState(false);
 const accordionRef1 = useRef(null);

 const toggleAccordion1 = () => {
     setIsOpenProfile1((prev) => {
       const newState = !prev;
       toggle('item-1', newState); // Ensure correct toggle
       return newState;
     });
   };
 
   useEffect(() => {
     document.addEventListener("mousedown", handleClickOutside);
     return () => {
       document.removeEventListener("mousedown", handleClickOutside);
     };
   }, [isOpenProfile1]);
 
   const handleClickOutside = (event) => {
     console.log('Clicked:', event.target);
   
     if (accordionRef1.current && !accordionRef1.current.contains(event.target)) {
       console.log('Closing accordion 1');
       setIsOpenProfile1(false);
       toggle('item-1', false);
     }
   };
 
   const changeLanguage = (lng) => {
     i18n.changeLanguage(lng);
   };

   const lightTheme = () => {
    localStorage.setItem('theme','light');
    setCurrentTheme('light');
    config.currentTheme = 'light';
    window.location.reload();
  }

  const darkTheme = () =>{
    localStorage.setItem('theme','dark');
    setCurrentTheme('dark');
    config.currentTheme = 'dark';
    window.location.reload();
  }

  return (
        <div className={`setting-box-container ${className}`}>
        <div ref={accordionRef1}>
          <ControlledAccordion providerValue={providerValue}>
             <AccordionItem as="span"
                itemKey="item-1"
                open={isOpenProfile1}
                onClick={toggleAccordion1}
                header={
                <div data-toggle="collapse" data-target="#settings-toggle" class="setting-icon collapsed" aria-expanded="false">
          <i class="fas fa-cog"></i>
        </div>}>
                  <div id="settings-toggle" class="setting-box collapse">
          <div>
            <h4>{t('theme')}</h4> 
            <div id="select-theme" class="collapse show setting-sub-box">
              <div class="language-switch">
                <div class={`${config.currentTheme === 'dark'? 'selected' :''}`} onClick={darkTheme}>
                  <span>{t('dark')}</span> <i class="fas fa-moon ml-2"></i>
                </div> 
                <div class={`${config.currentTheme === 'light'? 'selected' :''}`} onClick={lightTheme}>
                  <span>{t('light')}</span> <i class="fas fa-sun ml-2"></i>
                </div>
              </div>
            </div>
          </div> 
          <div>
            <h4>{t('language')}</h4> 
            <div id="select-language" class="collapse show setting-sub-box">
              <div class="language-list">
                <div class={`${i18n.language === "hi" ? 'selected' : '' }`} onClick={() => changeLanguage('hi')}>हिंदी</div>
                <div class={`${i18n.language=="en-US" || i18n.language === "en" ? 'selected' : '' }`} onClick={() => changeLanguage('en')}>English</div>
                <div class={`${i18n.language === "mr" ? 'selected' : '' }`} onClick={() => changeLanguage('mr')}>मराठी</div>
                <div class={`${i18n.language === "gu" ? 'selected' : '' }`} onClick={() => changeLanguage('gu')}>ગુજરાતી</div>
                <div class={`${i18n.language === "ta" ? 'selected' : '' }`} onClick={() => changeLanguage('ta')}>தமிழ்</div>
              </div>
            </div>
          </div>
        </div>
              </AccordionItem>
          </ControlledAccordion>
        </div>
    </div>
  )
}
